"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var CommonAssessments_exports = {};
__export(CommonAssessments_exports, {
  default: () => CommonAssessments_default
});
module.exports = __toCommonJS(CommonAssessments_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M11.6719 3.58984C11.5807 3.79818 11.5026 4.02604 11.4375 4.27344C11.3854 4.50781 11.3529 4.7487 11.3398 4.99609V5.25H3.83984V15.25H17.1602V9.05859C17.4987 8.91536 17.8047 8.73307 18.0781 8.51172C18.3646 8.29036 18.6185 8.03646 18.8398 7.75V15.25C18.8398 15.7057 18.6771 16.0964 18.3516 16.4219C18.026 16.7474 17.6289 16.9102 17.1602 16.9102H3.83984C3.37109 16.9102 2.97396 16.7474 2.64844 16.4219C2.32292 16.0964 2.16016 15.7057 2.16016 15.25V5.25C2.16016 4.79427 2.32292 4.40365 2.64844 4.07812C2.97396 3.7526 3.37109 3.58984 3.83984 3.58984H11.6719ZM8 11.0898V14.4102H4.66016V11.0898H8ZM7.16016 11.9102H5.5V13.5898H7.16016V11.9102ZM15.5 11.9102V13.5898H9.66016V11.9102H15.5ZM6.75 12.3398V13.1602H5.91016V12.3398H6.75ZM8 6.08984V9.41016H4.66016V6.08984H8ZM9.66016 6.91016H11.6719C11.8281 7.2487 12.0169 7.5612 12.2383 7.84766C12.4596 8.12109 12.7135 8.36849 13 8.58984H9.66016V6.91016ZM15.5 1.91016C16.4115 1.91016 17.1927 2.24219 17.8438 2.90625C18.5078 3.55729 18.8398 4.33854 18.8398 5.25C18.8398 6.16146 18.5078 6.94922 17.8438 7.61328C17.1927 8.26432 16.4115 8.58984 15.5 8.58984C14.5755 8.58984 13.7878 8.26432 13.1367 7.61328C12.4857 6.94922 12.1602 6.16146 12.1602 5.25C12.1602 4.33854 12.4857 3.55729 13.1367 2.90625C13.7878 2.24219 14.5755 1.91016 15.5 1.91016ZM7.16016 6.91016H5.5V8.58984H7.16016V6.91016ZM6.75 7.33984V8.16016H5.91016V7.33984H6.75ZM15.5 2.63281C14.7708 2.63281 14.1589 2.88672 13.6641 3.39453C13.1823 3.90234 12.9414 4.52083 12.9414 5.25C12.9414 5.99219 13.1823 6.61719 13.6641 7.125C14.1589 7.61979 14.7708 7.86719 15.5 7.86719C16.2161 7.86719 16.8151 7.61979 17.2969 7.125C17.7917 6.61719 18.0391 5.99219 18.0391 5.25C18.0391 4.52083 17.7917 3.90234 17.2969 3.39453C16.8151 2.88672 16.2161 2.63281 15.5 2.63281ZM15.5 3.47266C15.9688 3.47266 16.3333 3.58984 16.5938 3.82422C16.8542 4.05859 17.0234 4.31901 17.1016 4.60547L16.2812 4.87891C16.2422 4.7487 16.1641 4.625 16.0469 4.50781C15.9297 4.3776 15.7539 4.3125 15.5195 4.3125C15.2982 4.3125 15.0964 4.39714 14.9141 4.56641C14.7448 4.72266 14.6602 4.95703 14.6602 5.26953C14.6602 5.56901 14.7448 5.80339 14.9141 5.97266C15.0964 6.14193 15.3047 6.22656 15.5391 6.22656C15.7734 6.22656 15.9492 6.16146 16.0664 6.03125C16.1966 5.90104 16.2812 5.77083 16.3203 5.64062L17.1211 5.91406C17.043 6.1875 16.8737 6.44792 16.6133 6.69531C16.3529 6.92969 15.9948 7.04688 15.5391 7.04688C15.0443 7.04688 14.6211 6.8776 14.2695 6.53906C13.931 6.20052 13.7617 5.77734 13.7617 5.26953C13.7617 4.7487 13.931 4.31901 14.2695 3.98047C14.6081 3.64193 15.0182 3.47266 15.5 3.47266Z",
      fill: "currentColor"
    }
  )
);
const SvgCommonAssessments = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var CommonAssessments_default = SvgCommonAssessments;
